import React from "react";
import { Modal, Divider, Select } from "antd";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import config from "../../config";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  dividerStyle: {
    marginTop: 14,
    marginBottom: 14,
    border: "0.5px solid #909090",
  },
  modalStyle: {
    "& .ant-modal-content": {
      borderRadius: "2rem",
    },
  },
  ButtonStyle: {
    backgroundColor: "#EF4667",
    color: "#fff",
    border: 0,
    borderRadius: "4px",
    paddingLeft: "34px",
    paddingRight: "34px",
    "&:hover": {
      backgroundColor: "#EF4667",
      color: "#fff",
    },
  },
  selectStyle: {
    "& legend": {
      display: "none",
    },
  },
  inputStyle: {
    "& label": {
      display: "none",
    },
  },
}));
const OutlineModal = ({ open, setOpen, outletArray }) => {
  const classes = useStyles();
  const shopId = useSelector((state) => state.shopDetails.shopId);
  const employeeId = useSelector((state) => state.shopDetails.empId);

  const handleSubmit = async () => {
    try {
      var res = await fetch(`${config.ApiGateway}/handleShopCounter`, {
        method: "post",
        headers: {
          "Content-type": "application/json",
        },
        // body: JSON.stringify({
        //   openBalance: startCounterBalance,
        //   employeeId,
        //   shopId,
        //   type: "start",
        //   counterOpenedTime: new Date().toLocaleTimeString("en-IN", {
        //     hour: "2-digit",
        //     minute: "2-digit",
        //   }),
        // }),
      });
      res = await res.json();
      if (res.code === "SUCCESS") {
        setOpen(false);
      }
      if (res.code === "ERROR") {
        return alert(res.message);
      }
    } catch (err) {
      console.log("ERR", err);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      footer={false}
      centered
      className={classes.modalStyle}
      width={700}
      closable={false}
      onFinish={handleSubmit}
    >
      <h3
        style={{
          color: "#EF4667",
          fontSize: 20,
        }}
      >
        Select your Outlet
      </h3>
      <p
        style={{
          color: "#99999F",
        }}
      >
        Which outlet you wish to visit?
      </p>
      <Divider className={classes.dividerStyle} />

      <h5>Outlet</h5>

      <Select
        style={{
          width: "100%",
          borderRadius: "8px",
        }}
        size="large"
      >
        {outletArray.map((i) => {
          return <Select.Option value={i.userId}>{i.outletArea}</Select.Option>;
        })}
      </Select>

      <Divider className={classes.dividerStyle} />
      <div
        style={{
          display: "flex",
          gap: "2rem",
        }}
      >
        {" "}
        <Button
          style={{
            background: "#FDECF0",
            width: "100%",
            color: "#EF4667",
          }}
          onClick={handleClose}
          size="large"
        >
          Cancel
        </Button>
        <Button
          style={{
            background: "#EF4667",
            width: "100%",
            color: "#fff",
          }}
          onClick={handleSubmit}
          size="large"
        >
          Submit
        </Button>
      </div>
    </Modal>
  );
};

export default OutlineModal;
